// PUBLIC EVALUATION REPORT ROUTE
// Route: /evaluation/:id
// Data source: GET /api/evaluation/result/{evaluation_id} — no auth, plain
// shareable link. Fetches the same v5 evaluation payload that /results
// reads from sessionStorage and hands it to the shared EvaluationReportView.

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { apiService } from '../services/apiService';
import { setTrackedEvaluationId } from '../services/journeyTracking';
import EvaluationReportView from './EvaluationReportView';

const EvaluationResultPage = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiService.getEvaluationResult(id)
      .then((res) => {
        if (cancelled) return;
        // Ties checkout order creation on this page back to this evaluation —
        // CheckoutPage.jsx reads this via getTrackedEvaluationId().
        setTrackedEvaluationId(id);
        setData({ analysis_result: res.evaluation, returning: true });
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setError(true);
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [id]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f6f4fd' }}>
        <Loader2 style={{ width: 32, height: 32, color: '#7c3aed' }} className="animate-spin" />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, background: '#f6f4fd', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, sans-serif" }}>
        <p style={{ fontSize: 16, fontWeight: 700, color: '#1a1130' }}>Evaluation not found.</p>
        <Link to="/" style={{ color: '#7c3aed', fontSize: 14, fontWeight: 600 }}>Go home</Link>
      </div>
    );
  }

  return <EvaluationReportView data={data} />;
};

export default EvaluationResultPage;
